var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"om-hairline",class:_vm.b(),attrs:{"href":_vm.url},on:{"click":_vm.onClick}},[_c('icon',{class:[_vm.b('icon'), _vm.iconClass],attrs:{"info":_vm.info,"name":_vm.icon}}),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319629f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/goods-action-mini-btn/index.vue
// module id = 1yzH
// module chunks = 76